import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
// primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { ToggleButton } from "primereact/togglebutton";
import { Accordion, AccordionTab } from "primereact/accordion";
// components
import Panel from "../../../../components/panel/panel";
import Modal from "../../../../components/modal/Modal";
import "../../../../components/input/MoneyInput/MoneyInput.css";
//services
import { getBlocks } from "../../../../services/GlobalRoles/getBlocks";
import { getSimulationInfo } from "../../../../services/Simulator/getSimulationInfo";
// utils
import { useContextSimulator } from "./SimulatorContext";
import { useAppContext } from "../../../../context/AppContext";
import { formatCurrency } from "../../../../utils/formatCurrency";
// modals
import ModalConfig from "./Modals/ModalConfig/ModalConfig";
import ModalSimulator from "./Modals/ModalSimulator/ModalSimulator";
import CashPayment from "./Accordions/CashPayment/CashPayment";
import EntryInstallments from "./Accordions/EntryInstallments/EntryInstallments";
import PlotsInstallments from "./Accordions/PlotsInstallments/PlotsInstallments";
import FinancingInstallments from "./Accordions/FinancingInstallments/FinancingInstallments";
import ConstructionInstallments from "./Accordions/ConstructionInstallments/ConstructionInstallments";
import OneTimeInstallment from "./Accordions/OneTimeInstallment/OneTimeInstallment";
import ModalBlockAndLand from "./Modals/ModalBlockAndLand/ModalBlockAndLand";
import { getPublicSimulationInfo } from "../../../../services/Public/getSimulationInfo";
import usePermission from "../../../../hooks/usePermission";
import { getEnvironment } from "../../../../utils/auth";

export default function Simulator({ crmData }) {
  const navigate = useNavigate();
  const environment_id = getEnvironment();
  const { id, hash, userId, role, token, appProfData, enterpriseId } = useParams(); // id from land
  // console.log({ id, hash, userId, role, token, appProfData, enterpriseId });
  // return;
  const { state } = useLocation(); // state.empId from enterprise
  const { nomenclatures, permissions } = useAppContext();

  const empId = state ? state.empId : crmData?.empId || 0;
  const fromCard = state ? state.fromCard : crmData?.fromCard;

  const nomenclature = JSON.parse(nomenclatures);
  const isPublic = hash ? true : false;
  // console.log("isPublic: ", isPublic);
  // console.log("empId: ", empId);

  usePermission("87", isPublic);

  const {
    generateEntryTerms,
    generateFinancingTerms,
    generateOneTimeTerms,
    calculateCorrection,
    handleSendSimulationModal,
    entryValue,
    selectedEntryTerm,
    simulatorData,
    setSimulatorData,
    firstEntryParcelDate,
    othersEntryParcelDate,
    entryParcelsTable,
    entryParcelsTableVisible,
    setEntryParcelsTableVisible,
    setEntryRange,
    setMinEntryValue,
    setEntryValue,
    setEntryTerms,
    entryTerms,
    setSelectedPricingTable,
    setConstructionRange,
    setMinConstructionValue,
    setConstructionValue,
    setFinancingValue,
    setFinancingParcelsTableVisible,
    financingParcelsTableVisible,
    date,
    setFinancingTerms,
    setIntermediateValue,
    setMinIntermediateValue,
    setIntermediateRange,
    setOneTimePayTerms,
    financingParcelsTable,
    entryParcelCalc,
    financingParcelCalc,
    totalOrderPrice,
    setTotalOrderPrice,
    showModalClient,
    setShowModalClient,
    setPricingTables,
    testId,
    setTestId,
    skeleton,
    setSkeleton,
    setBlocks,
    configVisible,
    setConfigVisible,
    setCurrentBlock,
    setCurrentLand,
    intermediateFinalValue,
    intermediateTotalValue,
    constructionTotalValue,
    constructionFinalValue,
    oneTimeParcelValue,
    setOneTimeParcelValue,
    landValue,
    setLandValue,
    toggle,
    setToggle,
    firstVisible,
    setFirstVisible,
    oneTimeParcelDate,
    translatePricingTablesTagToPortuguese,
    chooseEntry,
    setSelectedCorr,
    setClientId,
    setPublicClientData,
    setCrmData,
    setStage,
  } = useContextSimulator();

  useEffect(() => {
    if (crmData) {
      setCrmData(crmData);
    }
  }, [crmData]);

  const [decodedData, setDecodedData] = useState(null);
  useEffect(() => {
    if (appProfData && appProfData !== "undefined") {
      console.log("Oi");
      const decode = JSON.parse(atob(appProfData));
      setDecodedData(decode);
      if (role === "Cliente" && decode) {
        let typeDoc;
        if (decode?.doc <= 14) {
          typeDoc = 1;
        } else {
          typeDoc = 2;
        }
        setPublicClientData({
          doc: decode.doc,
          name: decode.name,
          phone: decode.phone || '',
          email: decode?.email || '',
          type_doc: typeDoc,
        })
      }
    }
    if (token && userId && role === "Corretor") {
      const TOKEN_KEY = "@walletLoteToken";
      localStorage.setItem(TOKEN_KEY, token);
    }
    console.log("Public Simulator Data: ", userId, role, token, appProfData, enterpriseId);
  }, [appProfData, token]);
  const [configActiveAccordion, setConfigActiveAccordion] = useState(0);
  const [firstActiveAccordion, setFirstActiveAccordion] = useState(0);

  const {
    data: blocks,
    isError,
    isLoading,
  } = useQuery({
    queryKey: [`blocks${!isPublic && empId}`],
    queryFn: () => getBlocks(!isPublic && empId),
    retry: false,
    cacheTime: 0,
    enabled: ((isPublic || id) && false),
  });

  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();

  useEffect(() => {
    if (isPublic) {
      handleSetAppSidebarNone(true);
      handleSetAppHeaderNone(true);
      handleSetAppContentClass("p-0");

      return () => {
        handleSetAppSidebarNone(false);
        handleSetAppHeaderNone(false);
        handleSetAppContentClass("");
      };
    }
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  useEffect(() => {
    if (!isPublic && fromCard) {
      if (!simulatorData) {
        setFirstVisible(true);
      }
      setFirstActiveAccordion(2);
      if (!id) {
        // console.warn("opa nao tem id ");
        setSkeleton(false);
      }
    }

    if (!isLoading && blocks) {
      const data = Object.keys(blocks)?.map((index) => {
        const dado = blocks[index];
        return {
          value: dado.id,
          label: dado.name,
        };
      });

      if (data) {
        data.sort((a, b) => a.label.localeCompare(b.label));
        setBlocks(data);
      }
      return;
    }
  }, [blocks]);

  useEffect(() => {
    // console.log("Teste: ", (hash && isPublic && (!role || role === undefined || role === "Cliente")))
    // console.log("Teste r: ", (!role || role === undefined || role === "Cliente"))
    // console.log("R: ", role)
    // console.log("testId: ", testId);
    // console.log("id: ", id);
    // console.log(state.fromCard);
    if (!isPublic && fromCard) {
      if (!simulatorData) {
        setFirstVisible(true);
      }
    }
    if ((id && isPublic && role === "Corretor") || ((id || testId) && !isPublic)) {
      setFirstVisible(false);
      setSkeleton(true);
      const fetchData = async () => {
        setSimulatorData(null);
        const param = testId ? testId : id;
        // console.log(param);
        // console.log(configVisible);
        // console.warn("Loading...");
        await getSimulationInfo(param)
          .then((res) => {
            if (res && res.error) {
              alert("Oops, algo deu errado. Tente novamente.");
              // console.log("Erro ao buscar dados da simulação: ", res.error);
            } else {
              console.log("Res: ", res);
              setLandValue(res.land_value);
              setFirstVisible(false);
              setSimulatorData(res);
              setSkeleton(false);
              setTestId(null);
            }
          })
          .catch((error) => {
            console.warn("Oops, algo deu errado. Tente novamente.");
            //            console.log(error);
            toast.error(error.response.data.error);
            setSkeleton(false);
            setCurrentBlock(null);
            setCurrentLand(null);
            setFirstVisible(true);
          });
      };

      fetchData();
      setFirstVisible(false);
      setSkeleton(true);
    } else if (hash && isPublic && (!role || role === "undefined" || role === "Cliente")) {

      setFirstVisible(false);
      setSkeleton(true);

      const fetchData = async () => {
        setSimulatorData(null);
        const sendData = {
          hash: hash,
          landId: id
        };
        await getPublicSimulationInfo(sendData)
          .then((res) => {
            if (res && res.error) {
              alert("Oops, algo deu errado. Tente novamente.");
              //              console.log("Erro ao buscar dados da simulação: ", res.error);
            } else {
              setLandValue(res.land_value);
              setFirstVisible(false);
              setSimulatorData(res);
              setSkeleton(false);
              setTestId(null);
            }
          })
          .catch((error) => {
            console.warn("Oops, algo deu errado. Tente novamente.");
            //            console.log(error);
            toast.error(error.response.data.error);
            setSkeleton(false);
            setCurrentBlock(null);
            setCurrentLand(null);
            setFirstVisible(true);
          });
      };

      fetchData();
      setFirstVisible(false);
      setSkeleton(true);
    }
  }, [id, testId, setSimulatorData]);

  useEffect(() => {
    if (isError) {
      toast.error("Oops, algo deu errado...\n Tente novamente.");
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSimulatorData(null);
    if (!id) {
      // setConfigVisible(false);
      setSimulatorData(null);
      setTestId(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (simulatorData) {
        /**Entry Values */
        if (simulatorData.min_entry_value) {
          let calculatedEntryValue;

          if (simulatorData.type_entry === 1) {
            calculatedEntryValue =
              (landValue / 100) * simulatorData.min_entry_value;
          } else if (simulatorData.type_entry === 2) {
            if (
              parseFloat(simulatorData.min_entry_value) >= parseFloat(landValue)
            ) {
              calculatedEntryValue = landValue;
            } else {
              calculatedEntryValue = simulatorData.min_entry_value;
            }
          }
          // const rangeInputEntryValue = calculatedEntryValue * 100;
          setEntryRange(calculatedEntryValue * 100);
          setMinEntryValue(calculatedEntryValue);
          setEntryValue(calculatedEntryValue);
        }
        /**End Entry Values */

        /**Construction Values */
        if (simulatorData.construction_payments_enable) {
          const calculatedConstructionValue =
            (landValue / 100) * simulatorData.construction_payments_percentage;

          setConstructionRange(calculatedConstructionValue * 100);
          setMinConstructionValue(calculatedConstructionValue);
          setConstructionValue(calculatedConstructionValue);
        }
        /**End Construction Values */

        /**Intermediate Values */
        if (simulatorData.intermediate_enable) {
          const calculatedIntermediateValue =
            (landValue / 100) * simulatorData.intermediate_percentage;
          // const rangeInputEntryValue = calculatedEntryValue * 100;
          setIntermediateRange(calculatedIntermediateValue * 100);
          setMinIntermediateValue(calculatedIntermediateValue);
          setIntermediateValue(calculatedIntermediateValue);
        }
        /**End Intermediate Values */

        /**One Time Installment */
        if (simulatorData.single_installment_enable) {
          const calculatedOneTimeInstallmentValue =
            (landValue / 100) * simulatorData.single_installment_percentage;

          setOneTimeParcelValue(
            parseFloat(calculatedOneTimeInstallmentValue).toFixed(2)
          );
        }
        /**End One Time Installment */

        /**Entry Terms */
        if (simulatorData.number_entrance_installments >= 1) {
          await generateEntryTerms(
            simulatorData.number_entrance_installments
          ).then((res) => setEntryTerms(res));
        } else if (simulatorData.number_entrance_installments === 0) {
          toast.warning(`
            O máximo de parcelas de entrada está configurado como: 
            ${simulatorData.number_entrance_installments},
            configure corretamente as configurações do simulador para evitar falhas.
          `);
        }
        /**End Entry Terms */

        /**Financing Terms */
        if (simulatorData.financing_max_installments >= 1) {
          await generateFinancingTerms(
            simulatorData.financing_max_installments
          ).then((res) => setFinancingTerms(res));
        } else if (simulatorData.financing_max_installments === 0) {
          toast.warning(`
            O máximo de parcelas de financiamento está configurado como: 
            ${simulatorData.financing_max_installments},
            configure corretamente as configurações do simulador para evitar falhas.
          `);
        }
        /**End Financing Terms */

        /**One Time Pay Terms */
        await generateOneTimeTerms(simulatorData.discounts_in_cash).then(
          (res) => setOneTimePayTerms(res)
        );
        /**One Time Pay Terms */

        /**Pricing Tables */
        const pricingTablesObj = [];
        const financingPricingTable = simulatorData.amortization_system.find(
          (e) => e.type === "financing"
        );
        const hasTrueValue = financingPricingTable
          ? ["price", "sac", "sac_inverso", "sacre", "sacre_ib", "sacoc", "interest_free"]
            .some((key) => financingPricingTable[key] === 1)
          : false;

        if (financingPricingTable !== undefined && hasTrueValue) {
          for (const [key, value] of Object.entries(financingPricingTable)) {
            if (
              key === "price" ||
              key.startsWith("sac") ||
              key === "interest_free"
            ) {
              if (value === 1) {
                const translatedName =
                  translatePricingTablesTagToPortuguese(key);

                pricingTablesObj.push({ value: key, label: translatedName });
              }
            }
          }


          // Allow this special pricing table only on localhost or homologation URL
          const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
          const isHomolog = typeof window !== 'undefined' && window.location.origin === 'https://homologation.walletlote.app.br';
          if (environment_id === '122' || environment_id === '125' || environment_id === '2') {
            pricingTablesObj.push({ value: "e122sacoc", label: "SACOC_E122" });
          }

          setPricingTables(pricingTablesObj);
          setTimeout(() => {
            setSelectedPricingTable(pricingTablesObj[0].value);
          }, 200);
        } else {
          if (!isPublic) {
            toast.error(
              "Você precisa selecionar ao menos uma tabela de amortização, nas configurações do simulador..."
            );
            if (crmData) {
              crmData.onHide();
            } else {
              navigate(`/enterpriseSettings/simulator/${empId}`, {
                state: { name: state ? state.name : "Empreendimento" },
              });
            }
          }
        }
      }
    };

    fetchData();
    setTotalOrderPrice(0);
  }, [simulatorData, landValue]);

  useEffect(() => {
    /**Aqui precisa adicionar a regra de sem juros c juros */
    //    console.log("entryParcelCalc ", entryParcelCalc);
    //    console.log("entryValue ", entryValue);

    //    console.log("financingParcelCalc", financingParcelCalc);
    //    console.log("intermediateFinalValue", intermediateTotalValue);
    //    console.log("constructionTotalValue", constructionTotalValue);
    //    console.log("oneTimeParcelValue", oneTimeParcelValue);
    if ((entryParcelCalc && entryValue) || (financingParcelCalc && date)) {
      let total = simulatorData?.installments_interest_entry
        ? parseFloat(entryParcelCalc)
        : parseFloat(entryValue);

      if (constructionTotalValue !== 0) {
        total += parseFloat(constructionTotalValue);
      }

      if (intermediateTotalValue !== 0) {
        total += parseFloat(intermediateTotalValue);
      }

      if (oneTimeParcelValue !== 0 && oneTimeParcelDate !== null) {
        total += parseFloat(oneTimeParcelValue);
      }

      // if (financingParcelCalc !== 0 && date) {
      if (financingParcelCalc !== 0 && date) {
        total += parseFloat(financingParcelCalc);
      }

      console.log("Total: ", formatCurrency(total));
      setTotalOrderPrice(total);
    }
  }, [
    entryParcelCalc,
    entryTerms,
    firstEntryParcelDate,
    othersEntryParcelDate,
    financingParcelCalc,
    intermediateTotalValue,
    constructionTotalValue,
    oneTimeParcelValue,
  ]);

  useEffect(() => {
    // console.log("First Entry: ", firstEntryParcelDate);
    // console.log("Date: ", date);
    const fetchFinancingValue = async () => {
      if (firstEntryParcelDate && date) {
        // console.log("Entrei")
        /**Agora precisa usar essa lógica quando alguma variável de entrada for alterada */
        const response = await calculateCorrection();
        //console.log("Financing Value: ", response);
        setFinancingValue(formatCurrency(response));
      }
    };

    fetchFinancingValue();
  }, [
    date,
    firstEntryParcelDate,
    othersEntryParcelDate,
    intermediateFinalValue,
    constructionFinalValue,
    entryValue,
    entryParcelCalc,
    entryTerms,
    financingParcelCalc,
    oneTimeParcelValue,
  ]);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-4">
          {/* <BreadCrumb
            model={item}
            className="breadCrumb"
            home={{ icon: "fa fa-home", url: "/salesManagement" }}
          /> */}
        </div>
        {skeleton && <Skeleton width="100%" height={`${isPublic ? "100vh" : "80vh"}`} />}

        {simulatorData && (
          <Panel mainCss={`col-12 ${isPublic && "100vh"} `}>
            <div className="container-fluid">
              <div className="row mb-1">
                <div className="col-xl-6 my-auto">
                  <h3 className="text-success pt-2">
                    {isPublic ? "Quadra" : nomenclature[0].value}: <b>{simulatorData.block_name}</b> /{" "}
                    {isPublic ? "Lote" : nomenclature[1].value}: <b>{simulatorData.land_name}</b>
                  </h3>
                </div>
                <div className="col-xl-3 col-md-6 text-end my-auto">
                  <ToggleButton
                    checked={toggle}
                    onChange={() => setToggle(!toggle)}
                    onLabel={"A Vista"}
                    offLabel={"Parcelamento"}
                    onIcon="pi pi-dollar"
                    offIcon="pi pi-credit-card"
                    className={`w-100 me - 3`}
                    tooltip="Clique para alternar entre pagamento 'A Vista' e 'Parcelado'"
                    tooltipOptions={{ position: "top" }}
                  />
                </div>
                <div className="col-xl-3 col-md-6 text-end my-auto">
                  <Button
                    icon="fa fa-md fa-cog"
                    onClick={() => {
                      setConfigActiveAccordion(0);
                      setConfigVisible(!configVisible);
                    }}
                    severity="secondary"
                    label="Configurações"
                    className="w-100"
                  />
                </div>
              </div>
              <hr />
              <div className="row">
                {!toggle ? (
                  <Accordion multiple activeIndex={[0]}>
                    <AccordionTab
                      header={
                        <div className="flex align-items-center">
                          <i className="pi pi-calendar me-2"></i>
                          <span className="vertical-align-middle">
                            Parcelas de Entrada
                          </span>
                        </div>
                      }
                    >
                      <EntryInstallments />
                    </AccordionTab>

                    {simulatorData &&
                      simulatorData.single_installment_enable && (
                        <AccordionTab
                          header={
                            <div className="flex align-items-center">
                              <i className="fa-regular fa-bookmark me-2"></i>
                              <span className="vertical-align-middle">
                                Parcela Única
                              </span>
                            </div>
                          }
                        >
                          <OneTimeInstallment />
                        </AccordionTab>
                      )}

                    {simulatorData &&
                      simulatorData.construction_payments_enable && (
                        <AccordionTab
                          header={
                            <div className="flex align-items-center">
                              <i className="fa-solid fa-screwdriver-wrench me-2"></i>
                              <span className="vertical-align-middle">
                                Parcelas de Construção
                              </span>
                            </div>
                          }
                        >
                          <ConstructionInstallments />
                        </AccordionTab>
                      )}

                    {simulatorData && simulatorData.intermediate_enable && (
                      <AccordionTab
                        header={
                          <div className="flex align-items-center">
                            <i className="fa-solid fa-sliders me-2"></i>
                            <span className="vertical-align-middle">
                              Parcelas Intermediárias
                            </span>
                          </div>
                        }
                      >
                        <PlotsInstallments />
                      </AccordionTab>
                    )}

                    <AccordionTab
                      header={
                        <div className="flex align-items-center">
                          <i className="pi pi-search me-2"></i>
                          <span className="vertical-align-middle">
                            Parcelas de Financiamento
                          </span>
                        </div>
                      }
                      disabled={
                        chooseEntry ||
                          (selectedEntryTerm === 1 && firstEntryParcelDate) ||
                          (selectedEntryTerm > 1 &&
                            firstEntryParcelDate &&
                            othersEntryParcelDate)
                          ? false
                          : true
                      }
                    >
                      <FinancingInstallments />
                    </AccordionTab>
                  </Accordion>
                ) : (
                  <Accordion multiple activeIndex={[0]}>
                    <AccordionTab
                      header={
                        <div className="flex align-items-center">
                          <i className="fa fa-file-invoice-dollar me-2"></i>
                          <span className="vertical-align-middle">A Vista</span>
                        </div>
                      }
                    >
                      <CashPayment />
                    </AccordionTab>
                  </Accordion>
                )}
              </div>
              <div className="row pt-4 justify-content-end">
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="float-end">
                    <label>Valor da Unidade:</label>
                    <p className="input">
                      {simulatorData && formatCurrency(landValue)}
                    </p>
                  </div>
                </div>
                {(toggle ||
                  parseFloat(totalOrderPrice).toFixed(2) >= parseFloat(landValue)) && (
                    <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="float-end">
                        <label>Total:</label>
                        <p className="input">{formatCurrency(totalOrderPrice)}</p>
                      </div>
                    </div>
                  )}
              </div>
              <div className="row justify-content-end my-4">
                <div className="col-xl-2 col-md-4">
                  <Button
                    label="Continuar"
                    className="w-100"
                    icon={"fa-solid fa-chevron-right"}
                    iconPos="right"
                    onClick={() => handleSendSimulationModal()}
                  />
                </div>
              </div>
            </div>
          </Panel>
        )}
      </div>

      {!isPublic && !id && (
        <Modal
          visible={firstVisible}
          dynamicTitle={`Selecione uma ${nomenclature[0].value} e ${nomenclature[1].value} para realizar uma simulação.`}
          onHide={() => {
            setFirstVisible(!firstVisible);
            if (crmData) {
              crmData.onHide();
            } else {
              navigate(`/enterprise/${empId} `, {
                // state: { name: enterprise.title },
              });
            }
          }}
          closable={true}
        >
          <ModalBlockAndLand
            activeAccordion={firstActiveAccordion}
            empId={empId}
          />
        </Modal>
      )}

      <Modal
        visible={configVisible}
        dynamicTitle={"Configurações do Simulador"}
        onHide={() => setConfigVisible(!configVisible)}
        closable={true}
      >
        <ModalConfig
          activeAccordion={configActiveAccordion}
          empId={!isPublic ? empId : 0}
        />
      </Modal>

      <Modal
        visible={showModalClient}
        dynamicTitle={`Realizar simulação`}
        onHide={() => {
          if (crmData) {
            crmData.setVisible(false);
          }
          setShowModalClient(false)
          setStage(0);
        }}
      >
        <ModalSimulator
          name={state ? state.name : "Empreendimento"}
          empId={!isPublic ? empId : 0}
          publicProps={{
            isPublic: isPublic || null,
            role: role || null,
            userId: userId || null,
            decodedData: decodedData || null
          }}
          hash={hash && hash}
        />
      </Modal>

      <Modal
        visible={entryParcelsTableVisible}
        dynamicTitle={`Parcelas de Entrada`}
        onHide={() => setEntryParcelsTableVisible(!entryParcelsTableVisible)}
        closable={true}
      >
        <DataTable value={entryParcelsTable} size={"normal"}>
          <Column field="installment" header="Parcela"></Column>
          <Column field="total" header="Valor"></Column>
        </DataTable>
      </Modal>

      <Modal
        visible={financingParcelsTableVisible}
        dynamicTitle={`Parcelas de Financiamento`}
        onHide={() =>
          setFinancingParcelsTableVisible(!financingParcelsTableVisible)
        }
        closable={true}
      >
        <DataTable value={financingParcelsTable} size={"normal"}>
          <Column field="installment" header="Parcela"></Column>
          <Column field="total" header="Valor"></Column>
        </DataTable>
      </Modal>
      {/* </SimuladorProvider> */}
    </>
  );
}
